import { IAction } from "../model/IAction";

export const UPDATE_MAJOR_VERSION = "UPDATE_MAJOR_VERSION";
export function updateMajorVersion(version: number): UpdateMajorVersionAction {
  return {
    type: UPDATE_MAJOR_VERSION,
    version: version
  };
}
export interface UpdateMajorVersionAction extends IAction {
  version: number;
}

export const UPDATE_MINOR_VERSION = "UPDATE_MINOR_VERSION";
export function updateMinorVersion(version: number): UpdateMinorVersionAction {
  return {
    type: UPDATE_MINOR_VERSION,
    version: version
  };
}
export interface UpdateMinorVersionAction extends IAction {
  version: number;
}
